<div
  class="list"
  data-cy="dashboard-location-preferences.list">
  <div
    *ngFor="let element of clientLocationPreferences?.locationPreferences; let i = index"
    class="list__element">
    <coa-dashboard-location-preferences-list-element
      [name]="element.locationName"
      [number]="i + 1"
      [percentageValue]="element.clientLocationVisitorsPercentage">
    </coa-dashboard-location-preferences-list-element>
  </div>
</div>
